export default __webpack_public_path__ + "static/media/high-five.9106d8f6.webp";